import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import '@/App.css';

import { LangProvider } from '@/i18n/LangContext';
import Header from '@/components/Header';
import Footer from '@/components/Footer';

import Home from '@/pages/Home';
import About from '@/pages/About';
import Services from '@/pages/Services';
import Products from '@/pages/Products';
import Quality from '@/pages/Quality';
import HowWeWork from '@/pages/HowWeWork';
import Geography from '@/pages/Geography';
import Contacts from '@/pages/Contacts';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: 'instant' in window ? 'instant' : 'auto' }); }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <LangProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/products" element={<Products />} />
              <Route path="/quality" element={<Quality />} />
              <Route path="/how-we-work" element={<HowWeWork />} />
              <Route path="/geography" element={<Geography />} />
              <Route path="/contacts" element={<Contacts />} />
              <Route path="*" element={<Home />} />
            </Routes>
          </main>
          <Footer />
        </BrowserRouter>
      </LangProvider>
    </div>
  );
}

export default App;
